<template>
  <div id="app" class="app-wrapper">
    <Header class="app-header"/>
    <main class="app-main">
      <router-view/>
    </main>
    <Footer class="app-footer"/>
    <GoTop/>
  </div>
</template>

<script>
export default { name: 'App' }
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
}
.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;   
}
.app-header {          
  flex-shrink: 0;
}
.app-main {
  flex: 1 0 auto;     
}
.app-footer {
  flex-shrink: 0;      
}
</style>


// WEBPACK FOOTER //
// src/App.vue